<nav class="pa-nav">
  <div class="pa-nav-logo">Han<span>dle</span></div>
  <button mat-button class="pa-nav-home" (click)="goHome()">
    <mat-icon>arrow_back</mat-icon>
    Back to Home
  </button>
</nav>

<div class="pa-page">
  <div class="pa-container">
    <!-- LEFT: DOCUMENT -->
    <div class="pa-main">
      <!-- PAGE TITLE -->
      <div class="pa-page-header">
        <div class="pa-page-title" role="heading" aria-level="1">Data Privacy Agreement</div>
        <div class="pa-page-meta">
          Constant Advancement — Handle Platform &nbsp;·&nbsp; FERPA (20 U.S.C. §1232g) &amp; COPPA
          (15 U.S.C. §6501)
        </div>
        @if (agreedAt) {
          <div
            class="pa-status pa-status--agreed"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            <mat-icon aria-hidden="true">check_circle</mat-icon>
            Acknowledged on {{ agreedAt | date: 'MMMM d, yyyy' }}
          </div>
        } @else {
          <div
            class="pa-status pa-status--pending"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            <mat-icon aria-hidden="true">schedule</mat-icon>
            Pending your acknowledgment
          </div>
        }
      </div>

      <mat-divider aria-hidden="true"></mat-divider>

      <!-- SECTION 1 -->
      <section class="pa-section" aria-labelledby="privacy-section-1">
        <div class="pa-section-header">
          <span class="pa-section-num" aria-hidden="true">1</span>
          <h2 class="pa-section-title" id="privacy-section-1">Introduction</h2>
        </div>
        <div class="pa-section-body">
          <p>
            This agreement describes how Constant Advancement collects, uses, stores, and protects
            your personally identifiable information (PII) through the Handle platform. By using
            Handle, you are subject to the protections and responsibilities outlined in this
            document.
          </p>
          <p>
            Handle is designed to comply with the Family Educational Rights and Privacy Act (FERPA)
            and the Children's Online Privacy Protection Act (COPPA). Please read this document
            carefully before acknowledging.
          </p>
        </div>
      </section>

      <mat-divider aria-hidden="true"></mat-divider>

      <!-- SECTION 2 -->
      <section class="pa-section" aria-labelledby="privacy-section-2">
        <div class="pa-section-header">
          <span class="pa-section-num" aria-hidden="true">2</span>
          <h2 class="pa-section-title" id="privacy-section-2">Your Rights Under FERPA</h2>
        </div>
        <div class="pa-section-body">
          <p>
            Under the Family Educational Rights and Privacy Act (FERPA), 20 U.S.C. §1232g, you have
            the following rights with respect to your education records:
          </p>

          <div class="pa-right">
            <div class="pa-right-title">§99.10 — Right to Inspect and Review</div>
            <p>
              You have the right to inspect and review your education records maintained by Handle
              within 45 days of a request. To exercise this right, contact Constant Advancement
              directly.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">§99.20 — Right to Request Amendment</div>
            <p>
              You have the right to request that Handle amend records you believe are inaccurate,
              misleading, or in violation of your privacy rights. Handle will respond to such
              requests within a reasonable period of time.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">§99.30 — Right to Control Disclosure</div>
            <p>
              You have the right to consent to disclosures of personally identifiable information
              from your education records, except where FERPA authorizes disclosure without consent
              (e.g. to school officials with a legitimate educational interest).
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">§99.32 — Right to Know Who Has Accessed Your Records</div>
            <p>
              Handle maintains a log of every access to your education records, including who
              accessed them, when, and for what legitimate purpose. You may request to review this
              log at any time.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">§99.63 — Right to File a Complaint</div>
            <p>
              You have the right to file a complaint with the U.S. Department of Education if you
              believe Handle has failed to comply with FERPA requirements. Complaints may be filed
              with the Family Policy Compliance Office, U.S. Department of Education, 400 Maryland
              Avenue SW, Washington, DC 20202.
            </p>
          </div>
        </div>
      </section>

      <mat-divider aria-hidden="true"></mat-divider>

      <!-- SECTION 3 -->
      <section class="pa-section" aria-labelledby="privacy-section-3">
        <div class="pa-section-header">
          <span class="pa-section-num" aria-hidden="true">3</span>
          <h2 class="pa-section-title" id="privacy-section-3">Children's Privacy (COPPA)</h2>
        </div>
        <div class="pa-section-body">
          <p>
            The Children's Online Privacy Protection Act (COPPA), 15 U.S.C. §6501, applies to users
            under 13 years of age. Handle is committed to protecting the privacy of all users,
            including minors.
          </p>

          <div class="pa-right">
            <div class="pa-right-title">What We Collect</div>
            <p>
              Handle collects only the information necessary to provide our services: name, email
              address, grade level, school, and any profile content you choose to share. We do not
              collect date of birth, phone numbers, home address, social security numbers, device
              identifiers, or geolocation data.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">How We Use It</div>
            <p>
              Your information is used solely to provide Handle's counseling and career planning
              features. We do not sell, rent, or share your personally identifiable information with
              third parties for commercial purposes.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">Parental Rights</div>
            <p>
              Parents or guardians of users under 13 may at any time review their child's
              information, request its deletion, or refuse further collection by contacting Constant
              Advancement. We will respond to such requests within a reasonable period of time.
            </p>
          </div>
        </div>
      </section>

      <mat-divider aria-hidden="true"></mat-divider>

      <!-- SECTION 4 -->
      <section class="pa-section" aria-labelledby="privacy-section-4">
        <div class="pa-section-header">
          <span class="pa-section-num" aria-hidden="true">4</span>
          <h2 class="pa-section-title" id="privacy-section-4">How Handle Protects Your Data</h2>
        </div>
        <div class="pa-section-body">
          <div class="pa-right">
            <div class="pa-right-title">Encryption at Rest</div>
            <p>
              All personally identifiable information stored in Handle's database is encrypted using
              AES-256-GCM authenticated encryption. Your data cannot be read even if someone gains
              direct access to the database.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">Encryption in Transit</div>
            <p>
              All data transmitted between your browser and Handle's servers is protected using
              HTTPS. Handle does not permit unencrypted HTTP connections in production.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">Access Control</div>
            <p>
              Only your assigned counselor and authorized Constant Advancement administrators may
              access your education records. Role-based access controls prevent unauthorized users
              from viewing your data.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">Audit Logging</div>
            <p>
              Every access to your education records is automatically logged with a timestamp, the
              identity of the accessor, and the reason for access, in compliance with FERPA §99.32.
              These logs are retained and available for review upon request.
            </p>
          </div>

          <div class="pa-right">
            <div class="pa-right-title">Authentication</div>
            <p>
              Handle uses Google OAuth exclusively for authentication, locked to the
              constantadvancement.com domain. No passwords are stored in Handle's database.
            </p>
          </div>
        </div>
      </section>

      <mat-divider aria-hidden="true"></mat-divider>

      <!-- SECTION 5 -->
      <section class="pa-section" aria-labelledby="privacy-section-5">
        <div class="pa-section-header">
          <span class="pa-section-num" aria-hidden="true">5</span>
          <h2 class="pa-section-title" id="privacy-section-5">Acknowledgment</h2>
        </div>
        <div class="pa-section-body">
          @if (agreedAt) {
            <div class="pa-agreed-box" role="status" aria-live="polite" aria-atomic="true">
              <mat-icon class="pa-agreed-icon" aria-hidden="true">check_circle</mat-icon>
              <div>
                <div class="pa-agreed-title">Agreement acknowledged</div>
                <div class="pa-agreed-date">
                  Agreed on {{ agreedAt | date: 'MMMM d, yyyy, h:mm a' }}
                </div>
              </div>
            </div>
          } @else {
            <p>
              By checking the box below and clicking "I Acknowledge", you confirm that you have read
              and understood your rights and responsibilities under FERPA and COPPA, and you agree
              to Handle's data privacy practices as described in this document.
            </p>
            <mat-checkbox
              class="pa-checkbox"
              [(ngModel)]="hasRead"
              aria-label="I have read and understood this data privacy agreement in full"
            >
              I have read and understood this data privacy agreement in full
            </mat-checkbox>
            <div class="pa-actions">
              <button
                mat-flat-button
                class="pa-btn-agree"
                [disabled]="!hasRead || isSaving"
                (click)="agree()"
                aria-label="Acknowledge data privacy agreement"
              >
                {{ isSaving ? 'Saving...' : 'I Acknowledge' }}
              </button>
            </div>
          }
        </div>
      </section>
    </div>

    <!-- RIGHT: SIDEBAR -->
    <div class="pa-side">
      <mat-card class="pa-side-card">
        <mat-card-content>
          <div class="pa-side-title" role="heading" aria-level="2">Status</div>
          <mat-divider style="margin: 8px 0 14px" aria-hidden="true"></mat-divider>
          <div class="pa-checklist" role="list" aria-label="Agreement status checklist">
            <div class="pa-check-item" role="listitem">
              <mat-icon
                aria-hidden="true"
                [class.pa-check-done]="agreedAt"
                [class.pa-check-missing]="!agreedAt"
              >
                {{ agreedAt ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              <span>FERPA rights acknowledged</span>
            </div>
            <div class="pa-check-item" role="listitem">
              <mat-icon
                aria-hidden="true"
                [class.pa-check-done]="agreedAt"
                [class.pa-check-missing]="!agreedAt"
              >
                {{ agreedAt ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              <span>COPPA notice reviewed</span>
            </div>
            <div class="pa-check-item" role="listitem">
              <mat-icon
                aria-hidden="true"
                [class.pa-check-done]="agreedAt"
                [class.pa-check-missing]="!agreedAt"
              >
                {{ agreedAt ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              <span>Agreement signed</span>
            </div>
          </div>
          @if (!agreedAt) {
            <p class="pa-side-hint" role="status">
              Scroll to the bottom of the document to acknowledge.
            </p>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="pa-side-card">
        <mat-card-content>
          <div class="pa-side-title" role="heading" aria-level="2">Sections</div>
          <mat-divider style="margin: 8px 0 14px" aria-hidden="true"></mat-divider>
          <ol class="pa-toc" aria-label="Document sections">
            <li>Introduction</li>
            <li>Your Rights Under FERPA</li>
            <li>Children's Privacy (COPPA)</li>
            <li>How Handle Protects Your Data</li>
            <li>Acknowledgment</li>
          </ol>
        </mat-card-content>
      </mat-card>

      <mat-card class="pa-side-card">
        <mat-card-content>
          <div class="pa-side-title" role="heading" aria-level="2">Questions?</div>
          <mat-divider style="margin: 8px 0 14px" aria-hidden="true"></mat-divider>
          <p class="pa-side-text">
            For questions about your privacy rights or how your data is used, contact Constant
            Advancement directly.
          </p>
          <p class="pa-side-text">
            To file a FERPA complaint with the U.S. Department of Education:
          </p>

          <a
            href="https://studentprivacy.ed.gov"
            target="_blank"
            mat-stroked-button
            class="pa-side-link"
            aria-label="Open studentprivacy.ed.gov in a new tab"
          >
            <mat-icon aria-hidden="true">open_in_new</mat-icon>
            studentprivacy.ed.gov
          </a>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
